import PhotoSeriesAlbum from "components/common/photo_series/album/PhotoSeriesAlbum";
import { usePhotoSeriesGet } from "hooks/citajteo/photo_series/usePhotoSeriesGet";
import { useParams } from "react-router-dom";

const GroupPhotoSeriesAlbum = () => {
  const { album } = useParams();
  const photoSeries = usePhotoSeriesGet(album as string, "slug");

  if (!photoSeries) {
    return <></>;
  }

  return <PhotoSeriesAlbum photoSeries={photoSeries} />;
};

export default GroupPhotoSeriesAlbum;
